import DotElement from "@/components/tableElements/DotElement.vue";
export default {
  name: "DashedPositionBar",
  components: {
    DotElement
  },
  props: {
    value: {
      type: [Number, null],
      required: true,
      default: 0
    },
    color: {
      type: String,
      required: true,
      default: "#312783"
    },
    max: {
      type: Number,
      required: true,
      default: 10
    }
  },
  data() {
    return {
      position: 0
    };
  },
  mounted() {
    if (!this.value) return 0;
    const bar = this.$refs.bar;
    const maxlenght = bar.getBoundingClientRect().width;
    this.position = this.value / this.max * maxlenght;
    this.position = this.position > maxlenght - 8 ? maxlenght - 8 : this.position;
  }
};